import axios from 'axios'

export function getContacts(locale) {
  return axios({
    method: 'GET',
    url: 'api/sales-static/contacts',
    params: { locale },
  })
}
